function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import PropTypes from 'prop-types';
import { breakPoint as breakPointAlt } from "../../styles/theme";
import { hoistStatics } from 'recompose';
import Media from 'react-media';
/**
 * A HOC to detect the device size and match up with breakPoint,
 * then pass it down to props
 * Sample usage:
 * <DomainSectionS12nList
 *    responsiveConfig={{
 *      xs: {initialS12nCount: 2},
 *      sm: {initialS12nCount: 2},
 *      md: {initialS12nCount: 4},
 *      lg: {initialS12nCount: 6},
 *      xl: {initialS12nCount: 8},
 *      xxl: {initialS12nCount: 8},
 *    }}
 *    ...
 *  />
 * */

function getComponentHtml(Component, props, breakPoint, showBreakPointNumber) {
  var addedProps = {
    breakPoint: breakPoint
  };

  if (showBreakPointNumber) {
    addedProps.breakPointNumber = breakPointAlt[breakPoint];
  }

  return React.createElement(Component, _extends({}, props, addedProps));
}

var withBreakPoint = function withBreakPoint(Component) {
  var componentName = Component.displayName || Component.name;

  var HOC = function HOC(props) {
    var showBreakPointNumber = props.showBreakPointNumber;
    return React.createElement(Media, {
      query: {
        minWidth: breakPointAlt.xxl
      }
    }, function (matchesXxl) {
      if (matchesXxl) {
        return getComponentHtml(Component, props, 'xxl', showBreakPointNumber);
      }

      return React.createElement(Media, {
        query: {
          minWidth: breakPointAlt.xl
        }
      }, function (matchesXl) {
        if (matchesXl) {
          return getComponentHtml(Component, props, 'xl', showBreakPointNumber);
        }

        return React.createElement(Media, {
          query: {
            minWidth: breakPointAlt.lg
          }
        }, function (matchesLg) {
          if (matchesLg) {
            return getComponentHtml(Component, props, 'lg', showBreakPointNumber);
          }

          return React.createElement(Media, {
            query: {
              minWidth: breakPointAlt.md
            }
          }, function (matchesMd) {
            if (matchesMd) {
              return getComponentHtml(Component, props, 'md', showBreakPointNumber);
            }

            return React.createElement(Media, {
              query: {
                minWidth: breakPointAlt.sm
              }
            }, function (matchesSm) {
              if (matchesSm) {
                return getComponentHtml(Component, props, 'sm', showBreakPointNumber);
              }

              return getComponentHtml(Component, props, 'xs', showBreakPointNumber);
            });
          });
        });
      });
    });
  };

  hoistStatics(Component, HOC);
  HOC.propTypes = {
    showBreakPointNumber: PropTypes.bool
  };
  HOC.displayName = "withBreakPoint(".concat(componentName, ")");
  return HOC;
};

export default withBreakPoint;